<template>
  <div class="about-page">
    <div class="container">

      <h1 class="about__title">{{ page_title }}</h1>
      <p class="about__lead">{{ page_lead }}</p>

      <div class="about__grid">
        <div v-for="b in blocks" :key="b.title" class="about-card">
          <div class="about-card__icon"><i :class="b.icon"></i></div>
          <div class="about-card__title">{{ b.title }}</div>
          <p class="about-card__body">{{ b.body }}</p>
        </div>
      </div>

      <div class="about__who">
        <h2 class="about__who-title">{{ who_title }}</h2>
        <p class="about__who-body">{{ who_body }}</p>
        <router-link to="/search" class="about__cta">{{ who_cta }} <i class="fa fa-arrow-right"></i></router-link>
      </div>

      <p class="about__sdg">{{ sdg_note }}</p>

    </div>
  </div>
</template>

<script>
import { cmsAbout } from '@/services/cms';
export default {
  metaInfo: { title: "Company — SherlockIT" },
  data() {
    return {
      page_title: "The missing layer of digital trust",
      page_lead:  "Across cybersecurity, financial systems, and supply chains, decisions are made every day on unverified corporate identity. SherlockIT is the infrastructure layer that fixes this — verified, real-time, and auditable.",
      who_title:  "Who we serve",
      who_body:   "RegTech & AML platforms, banking & financial institutions, ESG and supply-chain operators, cybersecurity teams, GovTech, and LegalTech firms — anywhere verified corporate identity is mission-critical.",
      who_cta:    "Try the demo",
      sdg_note:   "Aligned with UN SDG 16: transparency, accountability, and institutional trust.",
      blocks: [
        { icon: "fa fa-globe",    title: "Direct from source",   body: "APIs into 120+ official government registers. Multilingual, standardized, real-time." },
        { icon: "fa fa-shield",   title: "Court-admissible",     body: "Every record carries a timestamped chain of custody back to its official filing." },
        { icon: "fa fa-magic",    title: "Explainable AI",       body: "Cross-jurisdiction entity resolution with citations — no hallucinations, no black box." },
        { icon: "fa fa-building", title: "Built for enterprise", body: "SaaS portal, master API, on-premise, and LLM/vector feeds for sovereign deployments." },
      ],
    };
  },
  async mounted() {
    const applyAbout = (cms) => {
      if (cms.page_title) this.page_title = cms.page_title;
      if (cms.page_lead)  this.page_lead  = cms.page_lead;
      if (cms.who_title)  this.who_title  = cms.who_title;
      if (cms.who_body)   this.who_body   = cms.who_body;
      if (cms.who_cta)    this.who_cta    = cms.who_cta;
      if (cms.sdg_note)   this.sdg_note   = cms.sdg_note;
      if (cms.blocks?.length) this.blocks = cms.blocks;
    };
    const cms = await cmsAbout(this.$data, applyAbout.bind(this));
    applyAbout(cms);
  },
};
</script>

<style scoped>
.about-page { background: oklch(0.985 0.004 240); min-height: 60vh; padding: 40px 0 80px; }
.container { max-width: 900px; margin: 0 auto; padding: 0 24px; }

.about__title { font-size: clamp(1.75rem, 3.5vw, 2.5rem); font-weight: 600; letter-spacing: -0.02em; color: #0a1428; margin-bottom: 16px; }
.about__lead { font-size: 1.1rem; color: #64748b; line-height: 1.7; max-width: 680px; margin-bottom: 40px; }

.about__grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; margin-bottom: 48px; }
.about-card { border: 1px solid #e2e8f0; border-radius: 16px; background: #fff; padding: 20px; }
.about-card__icon { width: 36px; height: 36px; border-radius: 9px; background: rgba(87,94,207,0.1); color: #575ECF; display: flex; align-items: center; justify-content: center; font-size: 15px; margin-bottom: 12px; }
.about-card__title { font-size: 14px; font-weight: 600; color: #0a1428; margin-bottom: 6px; }
.about-card__body { font-size: 13px; color: #64748b; line-height: 1.65; margin: 0; }

.about__who { border: 1px solid #e2e8f0; border-radius: 20px; background: linear-gradient(135deg, rgba(87,94,207,0.05) 0%, #fff 100%); padding: 32px; margin-bottom: 32px; }
.about__who-title { font-size: 1.2rem; font-weight: 600; color: #0a1428; margin-bottom: 8px; }
.about__who-body { font-size: 14px; color: #64748b; line-height: 1.7; margin-bottom: 20px; }
.about__cta { display: inline-flex; align-items: center; gap: 6px; background: #575ECF; color: #fff; border-radius: 8px; padding: 8px 18px; font-size: 14px; font-weight: 500; text-decoration: none; transition: background 0.15s; }
.about__cta:hover { background: #4750b8; text-decoration: none; color: #fff; }

.about__sdg { font-size: 12px; color: #94a3b8; }

@media (max-width: 560px) { .about__grid { grid-template-columns: 1fr; } }
</style>
